import { useQuery } from 'react-query';
import axios from 'axios';

const useCreditsDisplayMutation = () => {
  return useQuery('credits', async () => {
    const { data } = await axios.get('/users/session');
    return data;
  });
};

export default useCreditsDisplayMutation;
